import { Box, HStack, Stack, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import {
  ColoredSkeleton,
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { reportGeneratorTheme } from '../../../../constants/theme';
import { RowActionsSkeleton } from '../shared/row/RowActions';

import { DocumentsTableSkeletonRowTable } from './table';

export const DocumentsTableSkeletonRow: React.FC = () => {
  const isTableLayout = useBreakpointValue({ base: false, sm: true });

  if (isTableLayout) {
    return <DocumentsTableSkeletonRowTable />;
  }

  return (
    <VStack
      space="stack.xxxs"
      mx="inline.xxxs"
      px="inset.xs"
      py="20px"
      bg={reportGeneratorTheme.table.rowBg}
      borderWidth={1}
      borderColor={reportGeneratorTheme.table.borderColor}
      borderRadius={reportGeneratorTheme.table.itemBorderRadius}>
      <HStack alignItems="center" justifyContent="space-between" width="full">
        <Stack w="2/5">
          <StatusSkeleton />
        </Stack>
        <RowActionsSkeleton />
      </HStack>

      <VStack space="stack.quarck" width="full">
        <TextSkeleton w="3/5" />
        <ColoredSkeleton height="12px" width="45%" borderRadius="sm" />
      </VStack>

      <Box w="full" h="1px" bg="neutral.lightest" />

      <HStack
        width="full"
        justifyContent="space-between"
        alignItems="flex-start"
        space="stack.quarck">
        <VStack flex={1} space="stack.quarck">
          <ColoredSkeleton height="12px" width="70%" borderRadius="sm" />
          <ColoredSkeleton height="16px" width="55%" borderRadius="sm" />
        </VStack>
        <VStack flex={1} space="stack.quarck" alignItems="flex-end">
          <ColoredSkeleton height="12px" width="80%" borderRadius="sm" />
          <ColoredSkeleton height="16px" width="60%" borderRadius="sm" />
        </VStack>
      </HStack>
    </VStack>
  );
};
